import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import Enableplaceordershippinghandling from "@tCentro/Store/Reducer/EnablePlaceOrderShippingHandlingState";
import { Draft } from "immer";

const initialState: Enableplaceordershippinghandling = {
    isSaveOrderShippingEnabled: false,
};

const reducer = {
    "Pages/EnableplaceordershippinghandlingState": (
        draft: Draft<Enableplaceordershippinghandling>,
        action: {
            isSaveOrderShippingEnabled: boolean;
        },
    ) => {
        draft.isSaveOrderShippingEnabled = action.isSaveOrderShippingEnabled;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
